var $033defe7e90b6d7a$exports = {};
$033defe7e90b6d7a$exports = {
    "breadcrumbs": `Chemin de navigation`
};


export {$033defe7e90b6d7a$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
